var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCodeAllCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.00195312C0.448 0.00195312 0 0.449953 0 1.00195V5.00195C0 5.55395 0.448 6.00195 1 6.00195H5C5.552 6.00195 6 5.55395 6 5.00195V1.00195C6 0.449953 5.552 0.00195312 5 0.00195312H1ZM8 0.00195312V2.00195H10V0.00195312H8ZM13 0.00195312C12.448 0.00195312 12 0.449953 12 1.00195V5.00195C12 5.55395 12.448 6.00195 13 6.00195H17C17.552 6.00195 18 5.55395 18 5.00195V1.00195C18 0.449953 17.552 0.00195312 17 0.00195312H13ZM2 2.00195H4V4.00195H2V2.00195ZM14 2.00195H16V4.00195H14V2.00195ZM8 4.00195V6.00195H10V4.00195H8ZM0 8.00195V10.002H2V8.00195H0ZM4 8.00195V10.002H6V8.00195H4ZM8 8.00195V10.002H10V8.00195H8ZM10 10.002V12.002H12V10.002H10ZM12 10.002H14V8.00195H12V10.002ZM14 10.002V12.002H16V10.002H14ZM16 10.002H18V8.00195H16V10.002ZM16 12.002V14.002H18V12.002H16ZM16 14.002H14V16.002H16V14.002ZM16 16.002V18.002H18V16.002H16ZM14 16.002H12V18.002H14V16.002ZM12 16.002V14.002H10V16.002H12ZM10 16.002H8V18.002H10V16.002ZM10 14.002V12.002H8V14.002H10ZM12 14.002H14V12.002H12V14.002ZM1 12.002C0.448 12.002 0 12.45 0 13.002V17.002C0 17.554 0.448 18.002 1 18.002H5C5.552 18.002 6 17.554 6 17.002V13.002C6 12.45 5.552 12.002 5 12.002H1ZM2 14.002H4V16.002H2V14.002Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeAllCards);
export default __webpack_public_path__ + "static/media/QrCode_AllCards.6ad16c5dee4f2dd8d678430c6aea5ed3.svg";
export { ForwardRef as ReactComponent };